import { render, staticRenderFns } from "./packageRenewal_bak.vue?vue&type=template&id=0c7fc666&scoped=true"
import script from "./packageRenewal_bak.vue?vue&type=script&lang=js"
export * from "./packageRenewal_bak.vue?vue&type=script&lang=js"
import style0 from "./packageRenewal_bak.vue?vue&type=style&index=0&id=0c7fc666&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7fc666",
  null
  
)

export default component.exports